module.exports = __webpack_public_path__ + "static/thirdScreen-bc03dc432aa971e8af4c5dad4dcd07b7.png";